<template>
<div class="ww">
  <ageList v-on:ageListEvent="ageListEvent" />
  <div class="wrap" v-loading="loading">
      <div class="headerBar">
          <div class="idc">
  <Candode v-on:childByValue="childByValue" ></Candode>
  </div>

<div class="idc">
 <el-select v-model="year" size="mini" placeholder="请选择时间">
    <el-option
      v-for="item in yearList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </div>
  <div class="idc">
 <el-select v-model="age" size="mini" clearable placeholder="请选择年龄段">
    <el-option
      v-for="item in agelist"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </div>
  <div class="idc">
 <el-select v-model="match_state" size="mini" placeholder="请选择状态" clearable>
    <el-option
      v-for="item in matchList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </div>
  <div class="idc">
   <el-select size="mini"  clearable  v-model="cblx" placeholder="参保类型">
    <el-option
      v-for="item6 in cblxList"
      :key="item6.value"
      :label="item6.label"
      :value="item6.value">
    </el-option>
  </el-select></div>
  <div class="idc">
   <el-select size="mini"  clearable  v-model="playStatu" placeholder="发放状态">
    <el-option
      v-for="item6 in playStatuList"
      :key="item6.value"
      :label="item6.label"
      :value="item6.value">
    </el-option>
  </el-select></div>
  <div class="idc">
  <el-input v-model="idcard" size="mini" clearable placeholder="请输入身份证号"></el-input>
</div>
<div class="idc">
   <el-select v-model="dcjd" @change="changeQuer" size="mini" placeholder="请选择导出季度" clearable>
    <el-option
      v-for="item in dcjdList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</div>
  <div class="idc">
  <el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="serch">查询</el-button>
   </div>
  
  <!-- <div class="colorMoudle">
      <div class="eiterLow">80以下</div>
      <div class="eiter">80-89</div>
      <div class="nine">90-99</div>
      <div class="hend">100以上</div>
  </div> -->
</div>
    <el-table
      :data="tableData"
      :span-method="objectSpanMethod"
     
      width="100%"
      border
      style="width: 100%; margin-top: 20px">
       <el-table-column
         align="center" 
        label="姓名"
        width="100">
        <template slot-scope="scope">
       {{ decrypt(scope.row.personName) }}
      </template>
       </el-table-column>
       <el-table-column
        label="地址"
        align="center" 
       >
        <template slot-scope="scope">
       {{(scope.row.townName?scope.row.townName:'')+(scope.row.villageName?scope.row.villageName:'')+(scope.row.groupName?scope.row.groupName:'') }}
      </template>
       </el-table-column>
       <el-table-column
        label="身份证号"
        width="180"
        align="center" 
       >
        <template slot-scope="scope">
       {{ decrypt(scope.row.identityNumber) }}
      </template>
       </el-table-column>
        <el-table-column
        label="银行卡号"
        width="180"
        align="center" 
       >
        <template slot-scope="scope">
       {{ scope.row.bankNo}}
      </template>
       </el-table-column>
       <!-- <el-table-column
        prop="totalPay"
        align="center" 
        label="待发金额"
        v-if="je"
        key='11'>
      </el-table-column>
       <el-table-column
        prop="totalGrant"
        align="center" 
        label="已发金额"
        v-if="df"
        key='10'
       >
      </el-table-column> -->
       <el-table-column
        prop="age"
       align="center" 
        label="年龄">
      </el-table-column>
       
       <el-table-column label="一季度" v-if="jdArr[0]" key='1' align="center">
    <el-table-column
        prop="gq1"
        label="金额"
        align="center">
      </el-table-column>
   <el-table-column
        prop="gstatus1"
        label="发放状态"
        align="center">
      </el-table-column>
    <el-table-column
        prop="gtime1"
        label="发放时间"
        align="center">
    </el-table-column>
    
        </el-table-column>
         <el-table-column label="二季度" v-if="jdArr[1]" key='2' align="center">
    <el-table-column
        prop="gq2"
        label="金额"
        align="center">
      </el-table-column>
   <el-table-column
        prop="gstatus2"
        label="发放状态"
        align="center">
      </el-table-column>
    <el-table-column
        prop="gtime2"
        label="发放时间"
        align="center">
    </el-table-column>
 
  
        </el-table-column>
        <el-table-column label="三季度" v-if="jdArr[2]" key='3' align="center">
    <el-table-column
        prop="gq3"
        label="金额"
        align="center"> 
      </el-table-column>
   <el-table-column
        prop="gstatus3"
        label="发放状态"
        align="center">
      </el-table-column>
    <el-table-column
        prop="gtime3"
        label="发放时间"
        align="center">
    </el-table-column>
    
 
        </el-table-column>
         <el-table-column label="四季度" v-if="jdArr[3]" key='4' align="center">
    <el-table-column
        prop="gq4"
        label="金额">
      </el-table-column>
   <el-table-column
        prop="gstatus4"
        label="发放状态">
      </el-table-column>
    <el-table-column
        prop="gtime4"
        label="发放时间">
    </el-table-column>
    
  
        </el-table-column>
      <!-- <el-table-column
      fixed="right"
      label="操作"
      width="100">
      <template slot-scope="scope">
        <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
       
      </template>
    </el-table-column> -->
    </el-table>
    <div class="btt">
     <el-pagination
  	class="pone"
      :page-size='10'
      layout="total, prev, pager, next, jumper"
      :total="totals"
      :current-page.sync="Page"
      @current-change="current_change"
>
    </el-pagination>
    <div>
    <!-- <el-button type="success" size="mini" icon="el-icon-download" @click="toExcel()">导出</el-button> -->
    </div> 
    </div>
    <div class="dcs" v-show="loading">
      <p class="ts">下载提示</p>
        <img src="../../assets/loading2.gif" alt="">
       <p class="succ">{{ismsg}}</p> 
       <div class="operad">
          <el-button type="success" style="float:left" @click="downloadExcel" v-show="isdown">下载</el-button>
           <el-button type="info" @click="qx"  style="float:right">取消</el-button>
       </div>
    </div>
  <el-dialog title="收货地址" :visible.sync="isdio">
  <el-form :model="form">
    <el-form-item label="活动名称" :label-width="formLabelWidth">
      <el-input v-model="form.name" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="活动区域" :label-width="formLabelWidth">
      <el-select v-model="form.region" placeholder="请选择活动区域">
        <el-option label="区域一" value="shanghai"></el-option>
        <el-option label="区域二" value="beijing"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
  </div>
</el-dialog>
  </div>
  </div>
</template>

<script>
import getColor from "../../utils/getColor";
import Candode from "../Core/candode";
import baseUrl from "../../utils/global";
import CryptoJS from "crypto-js";
import { getType } from "../../utils/typeAuth";
import getjd from "../../utils/getjd";
import ageList from "../../utils/ageList.vue";
export default {
  components: {
    Candode,
    ageList
  },
  data() {
    return {
      formLabelWidth: "200px",
      isdio: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      df: true,
      je: true,
      jdArr: [false, false, false, false],
      jd: "",
      ismsg: "文件生成中...",
      isdown: false,
      loading: false,
      age: "",
      state: "",
      stateList: "",
      dcjd: "",
      dcjdList: [
        {
          label: "一季度",
          value: 1
        },
        {
          label: "二季度",
          value: 2
        },
        {
          label: "三季度",
          value: 3
        },
        {
          label: "四季度",
          value: 4
        }
      ],
      playStatu: "",
      playStatuList: [
        {
          label: "已发放",
          value: 0
        },
        {
          label: "未发放",
          value: 1
        }
      ],
      match_state: "",
      matchList: [
        {
          label: "正常",
          value: 0
        },
        {
          label: "已死亡",
          value: 5
        }
      ],
      agelist: "",
      totals: 0,
      Page: 1,
      yes: "el-icon-check yes",
      noo: "el-icon-close noo",
      idcard: "",
      townList: "",
      year: 2020,
      yearList: [],
      tableData: [],
      cblx: "",
      cblxList: [],
      xzres: ""
    };
  },
  methods: {
    current_change(s) {
      this.getpage(s);
    },
    //编辑
    handleClick(s) {
      console.log(s);
    },
    serch() {
      // const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";

      // if (!isTown) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择县/区及以下区域进行操作"
      //   });
      //   return;
      // }
      this.getpage(1);
    },
    ageListEvent(s) {
      this.agelist = s;
    },
    //下载
    downloadExcel() {
      window.location.href = this.xzres;
    },
    qx() {
      (this.loading = false), (this.isdown = false);
    },
    //选择季度
    changeQuer() {
      this.jdArr = [false, false, false, false];
      this.je = false;
      this.df = false;
      if (this.dcjd == 1) {
        this.jdArr = [true, false, false, false];
      } else if (this.dcjd == 2) {
        this.jdArr = [false, true, false, false];
      } else if (this.dcjd == 3) {
        this.jdArr = [false, false, true, false];
      } else if (this.dcjd == 4) {
        this.jdArr = [false, false, false, true];
      } else {
        this.jdArr = [true, true, true, true];
        this.je = true;
        this.df = true;
      }
    },
    getpage(s) {
      let data = {
        dataState: this.match_state,
        birthday: this.age,
        //verify_type:10,
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        years: this.year,
        quarter: this.dcjd,
        pageNum: s,
        pageSize: 10,
        town: this.townList[3] ? this.townList[3].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        village: this.townList[4] ? this.townList[4].split(",")[1] : "",
        identityNumber: this.idcard ? this.Encrypt(this.idcard) : "",
        verify_type: this.cblx,
        playStatu: this.playStatu
      };
      this.$api.getlist
        .queryExcel(data)
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.totals = res.data.total;
          } else {
            this.tableData = [];
            this.totals = 0;
            this.$message({
              type: "warning",
              message: res.message
            });
          }
        })
        .catch(err => {});
    },
    toDC() {
      this.$confirm("导出，即标注津贴发放完结", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.toExcel();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导出"
          });
        });
    },
    toExcel() {
      this.loading = true;
      let data = {
        dataState: this.match_state,
        birthday: this.age,
        //verify_type:10,
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        years: this.year,
        quarter: this.dcjd,
        pageNum: 1,
        pageSize: 10,
        town: this.townList[3] ? this.townList[3].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        village: this.townList[4] ? this.townList[4].split(",")[1] : "",
        identityNumber: this.idcard ? this.Encrypt(this.idcard) : "",
        verify_type: this.cblx,
        playStatu: this.playStatu
      };
      this.$api.getlist
        .toee(data)
        .then(res => {
          var that = this;
          if (res.code == 200) {
            //this.loading=false
            this.isdown = true;
            this.ismsg = "文件生成成功!";
            this.xzres =
              baseUrl.baseUrl + "/download/excel?fileName=" + res.result;
          } else {
            this.loading = false;
            this.$message(res.describe);
          }
        })
        .catch(res => {
          this.$message("导出失败!");
          this.loading = false;
        });
    },
    childByValue(val) {
      this.townList = val;
      // this.serchCode()
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex === 0) {
      //   if (rowIndex % 2 === 0) {
      //     return {
      //       rowspan: 2,
      //       colspan: 1
      //     };
      //   } else {
      //     return {
      //       rowspan: 0,
      //       colspan: 0
      //     };
      //   }
      // }
    },
    // cellS({row, column, rowIndex, columnIndex}){
    //  return getColor({row, column, rowIndex, columnIndex})
    // },
    Encrypt(word) {
      //aes加密
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    decrypt(word) {
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    }
  },
  created() {
    let month = new Date().getMonth() + 1;
    switch (getjd(month)) {
      case 1:
        this.jdArr[0] = true;
        this.dcjd = 1;
        break;
      case 2:
        this.jdArr[1] = true;
        this.dcjd = 2;
        break;
      case 3:
        this.jdArr[2] = true;
        this.dcjd = 3;
        break;
      case 4:
        this.jdArr[3] = true;
        this.dcjd = 4;
        break;
    }
    let year = new Date().getFullYear();
    for (let i = year; i > year - 5; i--) {
      this.yearList.push({
        label: i,
        value: i
      });
    }
    let arr;
    if (sessionStorage.getItem("typeControll") == "null") {
      arr = JSON.parse(sessionStorage.getItem("codes"));
    } else {
      arr = JSON.parse(sessionStorage.getItem("typeControll"));
    }

    for (let i in arr) {
      this.cblxList.push({
        label: getType(arr[i]),
        value: arr[i]
      });
    }
    this.cblx = arr[0];
  }
};
</script>
<style>
.noo {
  color: #f56c6c;
}
.operad {
  width: 90%;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 10px;
}
.succ {
  text-align: center;
}
.ts {
  margin: 0;
  padding: 10px;
  background: #f8f8f8;
}
.ww .wrap {
  position: relative;
  min-height: 500px;
}
.dcs {
  box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
  position: absolute;
  width: 40%;
  background: #fff;
  left: 25%;
  top: 40%;
  z-index: 2222;
}
.dcs img {
  width: 100%;
}
.yes {
  color: #67c23a;
  font-weight: bolder;
}
.pone {
  text-align: center;
  margin-top: 10px;
}
.headerBar {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.btt {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.colorMoudle {
  display: flex;
}
.eiterLow,
.eiter,
.nine,
.hend {
  width: 80px;
  text-align: center;
  color: #000000;
  height: 28px;
  line-height: 28px;
  border-radius: 10px;
  margin-right: 10px;
}
.eiterLow {
  background: #c4eebc;
}
.eiter {
  background: #eefafe;
}
.nine {
  background: #d7ebfa;
}
.hend {
  background: #b4d4f5;
}
.headerBar .idc {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Myvue/realMoney.vue